<template>
  <div class="flex items-center justify-center p-8">
    <h6
       :class="[
        'block text-center w-full',
        fontSizeClass,
        textColorClass,
        fontWeightClass
      ]"
    >
      <span class="mr-3">{{ message }}</span>
      <span class="spinner" />
    </h6>
  </div>
</template>
<script>
export default {
  props: {
    message: { type: String, default: '' },
      fontSize: { type: String, default: '' }, 
    textColor: { type: String, default: '' }, 
    fontWeight: { type: String, default: '' }, 
  },
  computed: {
    fontSizeClass() {
      return this.fontSize || 'text-base';
    },
    textColorClass() {
      return this.textColor || 'text-slate-800 dark:text-slate-300';
    },
    fontWeightClass() {
      return this.fontWeight || 'font-normal';
    },
  },
};
</script>
